import { render, staticRenderFns } from "./CheckInIndex.vue?vue&type=template&id=2c8b0968&scoped=true"
import script from "./CheckInIndex.vue?vue&type=script&lang=js"
export * from "./CheckInIndex.vue?vue&type=script&lang=js"
import style0 from "./CheckInIndex.vue?vue&type=style&index=0&id=2c8b0968&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b0968",
  null
  
)

export default component.exports